import moment from "moment";
import ProfileCard from "../../../components/ContactInfo/ProfileCard";
import MasterComponent from "../../../components/Forms";
import { constants } from "../../../constants/common";
import { MasterConfigs } from "../../../interfaces/entity";
import Badge from "../../../components/Badge";
import { Typography } from 'antd';
const { Paragraph, Text } = Typography;

const ContractInterviews = () => {

    const config: MasterConfigs = {
        api: () => '/contract_interview',
        isActionTab: true,
        getFormColumns: () => [
            {
                name: "interviewOwner",
                type: "select",
                label: "Interview Owner",
                isCombo: true,
                required: [{ required: true, message: "Interview Owner is required" }],
            },
            {
                name: "deal",
                type: "select",
                label: "Deal",
                isCombo: true,
                required: [{ required: true, message: "Deal is required" }],
            },
            {
                name: "developer",
                type: "select",
                label: "Developer",
                isCombo: true,
                required: [{ required: true, message: "Developer is required" }],
            },
            {
                label: "Interview Title",
                name: "interviewTitle",
                type: "text",
                span: 16,
                required: [{ required: true, message: "Interview Title is required" }],
            },
            {
                label: "Interview Type",
                name: "interview_type",
                type: "select",
                children: [
                    { name: "Screening", value: "Screening" },
                    { name: 'Coding', value: 'Coding' },
                    { name: "Technical Screening", value: "Technical" },
                    { name: 'Level 1', value: 'Level 1' },
                    { name: 'Level 2', value: 'Level 2' },
                    { name: 'Level 3', value: 'Level 3' },
                    { name: "HR", value: "HR" },
                    { name: "Manager", value: "Manager" },
                    { name: "Final", value: "Final" },
                ],
                required: [{ required: true, message: "Interview Round is required" }],
            },
            {
                label: "Interview Date & Time",
                name: "interview_datetime",
                type: "date",
                dateProps: { showTime: true, format: 'DD-MM-YYYY HH:mm A', showNow: true, showSecond: false },
                span: 8,
                required: [{ required: true, message: "Interview Date & Time is required" }],
            },
            {
                label: 'Duration',
                name: 'duration',
                type: 'text',
                inputProps: {
                    addonAfter: 'Min'
                }
            },
            {
                label: "Interview Link",
                name: "interview_link",
                type: "text",
                rules: [{ required: true, message: 'Interview Link is required' }]
            },
            {
                label: "Job Description",
                name: "job_description",
                type: "textarea",
                span: 16
            },
            {
                label: "Instructions",
                name: "instructions",
                type: "textarea",
                span: 16
            }
        ],
        getColumns: () => [
            {
                title: 'Developer',
                dataIndex: "developer",
                key: "developer",
                width: 200,
                fixed: 'left',
                render: (text) => <ProfileCard
                    size={30}
                    name={constants.GET_FULL_NAME(text)}
                    avatarUrl={text?.avatar ? process.env.FILE_URL + text?.avatar : null}
                    role={null}
                />
            },
            {
                title: 'Interview Status',
                dataIndex: "interviewStatus",
                key: "interviewStatus",
                width: 200,
                render: (text) => {
                    // ['Selected', 'Rejected', 'Inprogress', 'Response awaiting']
                    let color;
                    if (text == 'Selected') {
                        color = 'green'
                    } else if (text == 'Rejected') {
                        color = 'red'
                    } else if (text == 'Inprogress') {
                        color = 'yellow'
                    } else if (text == 'Response awaiting') {
                        color = 'orange'
                    }

                    return <Badge color={color} text={text} />
                }
            },
            {
                title: 'Deal',
                dataIndex: "deal",
                key: "deal",
                width: 200,
                render: (text) => text?.dealName
            },
            {
                title: 'Interview Title',
                width: 200,
                dataIndex: "interviewTitle",
                key: "interviewTitle"
            },
            {
                title: 'Interview Type',
                width: 200,
                dataIndex: "interview_type",
                key: "interview_type"
            },
            {
                title: 'Interview Link',
                width: 200,
                dataIndex: "interview_link",
                key: "interview_link",
                ellipsis: true,
                render: (text) => <Text copyable={{ text: text }} />
            },
            {
                title: 'Interview Date & Time',
                dataIndex: "interview_datetime",
                width: 200,
                key: "interview_datetime",
                fixed: 'right',
                render: (text) => {
                    if (!text) return 'N/A';

                    try {
                        // Handle date parsing - MongoDB stores dates in UTC but they represent Indian time originally
                        // We need to convert UTC back to IST (UTC + 5:30 hours)
                        let date;
                        if (typeof text === 'string') {
                            // Parse as UTC and convert to IST
                            date = moment.utc(text).utcOffset('+05:30');
                        } else if (text instanceof Date) {
                            // Parse Date object as UTC and convert to IST
                            date = moment.utc(text).utcOffset('+05:30');
                        } else {
                            // Fallback: try to parse normally
                            date = moment.utc(text).utcOffset('+05:30');
                        }

                        if (!date.isValid()) {
                            console.warn('Invalid date format:', text);
                            return 'Invalid Date';
                        }

                        // Format in Indian timezone format (DD-MM-YYYY hh:mm A)
                        return date.format('DD-MM-YYYY hh:mm A');
                    } catch (error) {
                        console.error('Error formatting date:', error, text);
                        return 'Invalid Date';
                    }
                }
            },
            {
                title: 'Duration',
                dataIndex: 'duration',
                key: "duration",
                fixed: 'right',
                width: 200,
                render: (text) => text + ' Min'
            },
            {

                title: 'Interview Owner',
                dataIndex: "interviewOwner",
                width: 200,
                fixed: 'right',
                key: "interviewOwner",
                render: (text) => <ProfileCard
                    size={30}
                    name={constants.GET_FULL_NAME(text)}
                    avatarUrl={text?.avatar ? process.env.FILE_URL + text?.avatar : null}
                    role={null}
                />
            },
        ],
        actions: [{
            name: "Schedule Interview", actionType: 'Add'
        }],
        combo: [
            {
                api: '/users',
                name: 'interviewOwner',
                idKey: '_id',
                render: (text) => <ProfileCard
                    size={30}
                    name={constants.GET_FULL_NAME(text)}
                    avatarUrl={text?.avatar ? process.env.FILE_URL + text?.avatar : null}
                    role={null}
                />
            },
            {
                api: '/deals',
                name: 'deal',
                idKey: '_id',
                render: (e) => e.dealName
            },
            {
                api: '/bench-developers',
                name: 'developer',
                idKey: '_id',
                render: (e) => [e.firstName, e.lastName].filter(Boolean).join(' ')
            },

        ]
    }


    return (<div>
        <MasterComponent config={config} />
    </div>
    )
}


export default ContractInterviews;